// EKSELENS · ERIO logo — official pinwheel star mark (traced from brand asset)
// + wordmark. The mark uses `currentColor`, so set its colour via text-* classes.

export const StarMark = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 800 800"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    data-testid="ek-star-mark"
  >
    <g transform="translate(0,800) scale(0.1,-0.1)" fill="currentColor" stroke="none">
      <path d="M3677 7383 c-3 -10 -119 -535 -257 -1168 -139 -632 -254 -1152 -256
-1154 -2 -2 -247 49 -544 114 -297 65 -542 116 -543 114 -5 -6 -128 -572 -125
-574 7 -5 1662 -364 1665 -362 8 9 640 2913 634 2919 -3 3 -123 32 -266 63
-143 31 -270 59 -282 61 -15 4 -23 0 -26 -13z M4630 6168 c-156 -16 -286 -31
-288 -33 -4 -4 158 -1686 163 -1693 3 -3 2969 290 2974 294 2 2 -9 134 -25
294 -22 224 -31 290 -42 290 -7 0 -537 -52 -1177 -115 -640 -63 -1172 -115
-1182 -115 -17 0 -22 37 -72 548 -29 301 -56 550 -60 553 -3 3 -134 -8 -291
-23z M697 4739 c-119 -203 -145 -255 -135 -264 7 -7 473 -281 1036 -610 984
-576 1022 -599 1009 -619 -28 -43 -538 -916 -543 -929 -4 -10 68 -57 247 -162
l253 -148 15 22 c64 97 848 1448 842 1453 -6 7 -2549 1497 -2566 1504 -6 3
-77 -109 -158 -247z M5648 3968 c-428 -187 -778 -345 -778 -351 0 -8 1169
-2688 1189 -2724 4 -8 92 26 274 105 235 103 268 119 264 137 -3 11 -217 504
-476 1095 -259 591 -470 1079 -467 1085 2 5 229 109 505 229 275 121 501 223
501 227 0 8 -214 500 -228 525 -5 9 -228 -84 -784 -328z M3078 2035 l-1118
-994 196 -221 196 -220 23 17 c13 10 415 367 895 793 479 426 874 775 879 775
5 0 174 -186 376 -413 l368 -413 36 34 c20 18 118 107 219 196 101 90 182 166
180 170 -5 11 -1122 1270 -1128 1270 -3 0 -508 -447 -1122 -994z" />
    </g>
  </svg>
);

export const Logo = ({ className = "", dark = false }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="ek-logo">
    <StarMark size={26} className={dark ? "text-ek-lilac" : "text-ek-purple"} />
    <span className="ek-wordmark">
      <span className={dark ? "text-white" : "text-ek-ink"}>EKSELENS</span>
      <span className={`mx-1.5 ${dark ? "text-ek-lilac" : "text-ek-purple"}`}>·</span>
      <span className={dark ? "text-ek-lilac" : "text-ek-purple"}>ERIO</span>
    </span>
  </div>
);
